export const HOME_PAGE_CONTENT = `\
## Amir Sharapov

### Software Engineer (2021 - Present)
`;
